import { Icon } from '@shopify/polaris';
import { TextAlignCenterIcon, TextAlignLeftIcon, TextAlignRightIcon } from '@shopify/polaris-icons';

export const AlignmentButtons = ({ disabled, onFocus }: { disabled?: boolean; onFocus?: () => void }) => {
  const handleAlign = (alignment: 'justifyLeft' | 'justifyCenter' | 'justifyRight' | 'justifyFull') => {
    document.execCommand(alignment, false, '');
    onFocus?.();
  };

  return (
    <div style={{ display: 'inline-flex' }}>
      <button
        onClick={() => handleAlign('justifyLeft')}
        title="Align Left"
        style={{
          padding: '4px 8px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px 0 0 4px',
          cursor: 'pointer',
        }}
        disabled={disabled}
      >
        <Icon source={TextAlignLeftIcon} tone="base" />
      </button>
      <button
        onClick={() => handleAlign('justifyCenter')}
        title="Align Center"
        style={{
          padding: '4px 8px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderLeft: 'none',
          cursor: 'pointer',
        }}
        disabled={disabled}
      >
        <Icon source={TextAlignCenterIcon} tone="base" />
      </button>
      <button
        onClick={() => handleAlign('justifyRight')}
        title="Align Right"
        style={{
          padding: '4px 8px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderLeft: 'none',
          borderRadius: '0 4px 4px 0',
          cursor: 'pointer',
        }}
        disabled={disabled}
      >
        <Icon source={TextAlignRightIcon} tone="base" />
      </button>
    </div>
  );
};
